import { Controller } from "@hotwired/stimulus"

// Small behaviours that used to live in inline `on*="…"` HTML attributes. Under
// an enforcing CSP those attributes are blocked (no script-src-attr
// 'unsafe-inline'), so they moved here and are wired via data-action (#49).
export default class extends Controller {
  static values = { url: String }

  // was onclick="event.stopPropagation();" — keep a menu/dropdown click local.
  stop(event) {
    event.stopPropagation()
  }

  // was onclick="this.showPicker()" — open a native date/time input picker.
  showPicker(event) {
    event.currentTarget.showPicker?.()
  }

  // was onclick="this.select()" — select the field's text for easy copy.
  selectAll(event) {
    event.currentTarget.select?.()
  }

  // was onclick="window.location='…'" — navigate from a clicked row.
  navigate() {
    if (this.urlValue) window.location = this.urlValue
  }

  // was onchange="this.form.requestSubmit()" — auto-submit a filter/select form
  // the Turbo-friendly way. requestSubmit() fires a real submit event, so Turbo
  // sees it and honours data-turbo-frame / data-turbo (a plain form.submit() does
  // not, which silently defeats a frame swap — #54). requestSubmit() with no
  // argument does NOT require a submit button; the earlier "needs a button" guess
  // was wrong and it is exactly what broke the Shops saved-filter frame swap.
  // Pick this by default; only reach for submitFormNative when you deliberately
  // want a full navigation with no submit event and no validation.
  submitForm(event) {
    const form = event.currentTarget.form
    if (!form) return
    if (form.requestSubmit) form.requestSubmit()
    else form.submit() // legacy browsers without requestSubmit — degrades to a full navigation
  }

  // was onchange="this.form.submit()" — auto-submit bypassing the submit event and
  // HTML validation (a full navigation). Explicit, so a form that later gains or
  // loses a submit button can't silently change its submit semantics.
  submitFormNative(event) {
    const form = event.currentTarget.form
    if (form) form.submit()
  }
}
